import './less/hamburger-menu-button.less';


(function() {
    // input mask

    document.getElementById('hamburger-label').onclick = function() {
        document.getElementById('hamburger-label').classList.toggle('active');
      }

})();